import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LoadMyCompaniesLinkContractSuccessAction, myCompaniesLinkContractActionTypes} from '../actions/companies-link-contract';
import {CompaniesList} from '../../company/models/companies-list';


export interface CompaniesLinkContractState {
  typeaheadQuery?: string;
  array: CompaniesList[];
}

const initialState: CompaniesLinkContractState = {
  typeaheadQuery: '',
  array: []
};

export function companiesLinkContractReducer(state: CompaniesLinkContractState = initialState, action: Action): CompaniesLinkContractState {
  switch (action.type) {
    case myCompaniesLinkContractActionTypes.LOAD:
      return handleLoadAction(state);
    case myCompaniesLinkContractActionTypes.LOAD_SUCCESS:
      return handleLoadSuccess(state, action);
    case myCompaniesLinkContractActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadAction(state: CompaniesLinkContractState): CompaniesLinkContractState {
  const newState = _.clone(state);
  newState.typeaheadQuery = state.typeaheadQuery;
  return newState;
}

function handleLoadSuccess(state: CompaniesLinkContractState, action: LoadMyCompaniesLinkContractSuccessAction): CompaniesLinkContractState {
  const newState = _.clone(state);
  const payload = _.clone(action.payload.array);
  // tslint:disable-next-line:no-any
  const companiesListArray: any[] = [];
  if (payload.length > 0) {
    payload.forEach(function ( item: CompaniesList, i: number): void {
        companiesListArray.push(Object.assign({}, {companyName: item.name + ' ( ' + item.logisticsIdentifier + ' )' }, {companyUuid: item.uuid}))
    });
  }
  newState.array = companiesListArray || [];
  return newState;
}

function handleLoadFailAction(state: CompaniesLinkContractState): CompaniesLinkContractState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const companiesLinkContractSelectors = {
  array: (state: CompaniesLinkContractState) => _.get(state, 'array', [])
};
